// Login.js
import React, { useState, useEffect } from 'react';
import './Login.css';
import { Container, Col } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import login_image from '../../assets/images/login/login-image.png';
import login_image_ar from '../../assets/images/login/login-image-ar.png';
import { axiosPost } from "../../utils/apis/api"
import { useTranslation } from '../../contexts/TranslationContext';

const Login = ({ url }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loginError, setLoginError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language");
  const loginImage = Lang === "ar" ? login_image_ar : login_image;

  const location = useLocation();
  const navigate = useNavigate();

 

  const handleLogin = async (event) => {
    event.preventDefault();

    setUsernameError('');
    setPasswordError('');
    setLoginError('');

    if (!username.trim()) {
      setUsernameError('Username is required');
      return;
    }

    if (!password.trim()) {
      setPasswordError('Password is required');
      return;
    }

    try {
      setIsLoading(true);

      const response = await axiosPost(`${url}/api/method/login`, {
        usr: username,
        pwd: password,
      }, {
        withCredentials: true
      });

      if (response.status !== 200) {
        throw new Error('Login failed');
      }

      const { authentication, full_name, user_image, sid, preferred_language } = response.data;

      const oldLanguage = Cookies.get('preferred_language')
        let pendingRedirectService = location.state?.redirectService || null;
        if (!pendingRedirectService) {
          const stored = localStorage.getItem("redirectService");
          if (stored) {
            try { pendingRedirectService = JSON.parse(stored); } catch {}
          }
      }

      if (oldLanguage && preferred_language !== oldLanguage) {
        // 2) Clear, then restore the redirect key so it survives the language switch
        const tmp = pendingRedirectService ? JSON.stringify(pendingRedirectService) : null;
        localStorage.clear();
        if (tmp) localStorage.setItem("redirectService", tmp);
      }

      Cookies.set('api_key', authentication.api_key);
      Cookies.set('api_secret', authentication.api_secret);
      Cookies.set('username', username);
      Cookies.set('full_name', full_name);
      Cookies.set('user_image', user_image);
      Cookies.set('sid', sid);
      Cookies.set('preferred_language', preferred_language);
      

      // Check for redirect service data - prioritize location state over localStorage
     const redirectService = pendingRedirectService || null;

      // Clear localStorage after successful login
      localStorage.removeItem("redirectService");

      if (redirectService) {
        // Redirect to services page with the service data
        navigate("/services", { 
          state: { 
            redirectService: redirectService
          } 
        });
      } else if (location.state?.from) {
        navigate(location.state.from);
      } else {
        navigate("/myPackages");
      }
    } catch (error) {
      setLoginError('Wrong username or password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth">
      <Container>
        <div className="row" style={{ alignItems: "center" }}>
          <Col lg={4} md={5} sm={12}>
            <h1 className="login-title">{t("LogIn")}</h1>
            <p className="login-para">
              {t("LogInText")}
            </p>
            <form className="login-fields">
              <div className="input-wrapper">
                <input
                  type="text"
                  className={`login-field user-field ${usernameError && 'error'}`}
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              {usernameError && <p className="error-message">{usernameError}</p>}

              <div className="input-wrapper">
                <input
                  type="password"
                  className={`login-field password-field ${passwordError && 'error'}`}
                  placeholder={"Password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              {passwordError && <p className="error-message">{passwordError}</p>}
              {loginError && <p className="error-message">{loginError}</p>}
              <div className="forget">
                <Link to={"/forgetpassword"} className="forget-link" href="#">
                  {t("ForgotYourPassword")}
                </Link>
                <div className="remember">
                  {/* Remember me checkbox if needed */}
                </div>
              </div>
              <div className="login-btn">
                <input
                  type="submit"
                  value={t("LogIn")}
                  onClick={handleLogin}
                  className={`login-submit ${isLoading ? 'disabled' : ''}`}
                  disabled={isLoading}
                />
              </div>
            </form>
            <div className="no-account">
              <p>
                {t("DontHaveAccount")}
              </p>
              <a href={'/register'}>
                {t("SignUpNow")}
              </a>
            </div>
          </Col>
          <Col lg={8} md={7} sm={6} className='display-image-col'>
            <img src={loginImage} className="login-img" alt='login' />
          </Col>
        </div>
      </Container>
    </div>
  );
};

export default Login;